import type { Company } from '../../Companies/Types/companyTypes';

export interface InvoiceCompanyLookup {
  id: number;
  name: string;
  nip: string;
  street: string;
  buildingNumber: string;
  apartmentNumber: string;
  postalCode: string;
  city: string;
  fullStreetAddress: string;
  cityWithPostalCode: string;
}

const normalizeValue = (value: string | undefined | null): string => value?.trim() ?? '';

export const mapCompanyToInvoiceLookup = (
  company: Company | undefined | null
): InvoiceCompanyLookup | undefined => {
  if (!company) {
    return undefined;
  }

  const street = normalizeValue(company.street);
  const buildingNumber = normalizeValue(company.buildingNumber);
  const apartmentNumber = normalizeValue(company.apartmentNumber);
  const postalCode = normalizeValue(company.postalCode);
  const city = normalizeValue(company.city);

  const fullStreetAddress = [street, [buildingNumber, apartmentNumber].filter(Boolean).join('/')]
    .filter(Boolean)
    .join(' ')
    .trim();

  const cityWithPostalCode = [postalCode, city].filter(Boolean).join(' ').trim();

  return {
    id: company.id,
    name: normalizeValue(company.name),
    nip: normalizeValue(company.nip),
    street,
    buildingNumber,
    apartmentNumber,
    postalCode,
    city,
    fullStreetAddress,
    cityWithPostalCode,
  };
};
